import type { DueState } from '@/domain/sla/dueState'

export type PendingKind =
  | 'CORRECTION' | 'APPROVAL' | 'RECEPTION' | 'RENDITION' | 'RENDITION_REVIEW' | 'INVOICE'
  | 'INVOICE_TEAM' | 'PROVIDER_APPROVAL' | 'PAYMENT_AUTHORIZATION'

export const PENDING_KINDS: readonly PendingKind[] = [
  'CORRECTION', 'APPROVAL', 'RECEPTION', 'RENDITION', 'RENDITION_REVIEW', 'INVOICE',
  'INVOICE_TEAM', 'PROVIDER_APPROVAL', 'PAYMENT_AUTHORIZATION',
]

export interface PendingItem {
  id: number
  kind: PendingKind
  number: string | null
  detail: string | null
  amount: number | null
  currency: string | null
  days: number | null
  dueState: DueState
  /** Society name; present for the requests of a request group. */
  society?: string | null
  /** uuid of the request group the item belongs to; null/absent for a standalone request. */
  requestGroup?: string | null
  /** The group's own consecutive; absent before the api numbers groups. */
  requestGroupNumber?: number | null
  /** Status code of the request (its stage); lets a folded group say where each part is. */
  action?: string | null
  /** Stored-issue-engine code (`READING_TOTALS_UNVERIFIED`, `SYNC_DOCUMENT_NOT_RETRIEVED`, …) when
   *  this row is an open actionable warning on an `INVOICE`; `null` for every other pending reason. */
  issueCode: string | null
}

export interface PendingGroup {
  kind: PendingKind
  tab: string | null
  showsTab: boolean
  count: number
  oldestDays: number | null
  dueState: DueState
  items: PendingItem[]
}

export interface PendingSummary {
  total: number
  groups: PendingGroup[]
}

export interface InboxNotification {
  id: number
  entity: string
  event: string
  title: string
  data: Record<string, unknown>
  readAt: string | null
  createdAt: string
}

export interface InboxPage {
  count: number
  notifications: InboxNotification[]
}

export interface InboxRepository {
  pending(limit: number): Promise<PendingSummary>
  notifications(pageSize: number, unread?: boolean): Promise<InboxPage>
  markRead(ids: number[]): Promise<void>
}
